import { DriverProgress, Badge, Objective } from '../types/tombola'
import { SearchByPhoneResponse } from '../types/api'
export function mapApiResponseToDriverProgress(
  apiResponse: SearchByPhoneResponse,
): DriverProgress {
  const driver = apiResponse.data.driver
  const challenges = apiResponse.data.challenges
  // Get rides data from the first challenge
  const ridesData = challenges[0]?.rides || {
    total_rides: 0,
    rides_left: 0,
    next_ticket_milestone: 300,
  }
  // Helper function to translate metric names
  const translateMetric = (metric: string): string => {
    const translations: { [key: string]: string } = {
      rides: 'courses',
      ride: 'course',
      trips: 'trajets',
      trip: 'trajet',
    }
    return translations[metric.toLowerCase()] || metric
  }
  // Collect all badges from all goals in all challenges
  const allBadges: Badge[] = []
  let badgeIndex = 0
  challenges.forEach((challenge) => {
    challenge.goals.forEach((goal) => {
      goal.badges.forEach((apiBadge) => {
        // Calculate unlock date based on badge position (most recent = last in array)
        // Spread badges over the last 30 days, with the last one being today
        const daysAgo = goal.badges.length - badgeIndex - 1
        const unlockedDate = new Date()
        unlockedDate.setDate(unlockedDate.getDate() - daysAgo)
        allBadges.push({
          id: `${apiBadge.name.toLowerCase().replace(/\s+/g, '-')}-${badgeIndex}`,
          name: apiBadge.name,
          description: `Badge pour ${apiBadge.value} ${translateMetric(goal.metric)}`,
          icon: apiBadge.icon,
          unlocked: true,
          unlockedAt: unlockedDate,
        })
        badgeIndex++
      })
    })
  })
  // Create objectives from goals
  const objectives: Objective[] = []
  challenges.forEach((challenge) => {
    challenge.goals.forEach((goal, index) => {
      objectives.push({
        id: `goal-${index}`,
        title: goal.name,
        current: 0,
        target: goal.target,
        completed: false,
        type: goal.frequency === 'daily' ? 'daily' : 'weekly',
      })
    })
  })
  return {
    name: driver.name,
    tickets: allBadges.length,
    rides: ridesData.total_rides,
    level: 'Bronze',
    nextLevelTickets: allBadges.length + 10,
    nextLevelRides: ridesData.next_ticket_milestone,
    badges: allBadges,
    objectives: objectives,
  }
}
